/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Cta_SubtitleInputs */

const he_home_cta_subtitle = /** @type {(inputs: Home_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הירשמו להתראות מחיר חינם ולא תשלמו יותר מדי.`)
};

const en_home_cta_subtitle = /** @type {(inputs: Home_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up for free price alerts and never overpay again.`)
};

/**
* | output |
* | --- |
* | "Sign up for free price alerts and never overpay again." |
*
* @param {Home_Cta_SubtitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_cta_subtitle = /** @type {((inputs?: Home_Cta_SubtitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Cta_SubtitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_cta_subtitle(inputs)
	return en_home_cta_subtitle(inputs)
});